import React, { useState } from 'react';
import { ToastProvider } from '../components/ui/Toast';
import { BirthdaysTodayWidget } from '../components/widgets/BirthdaysTodayWidget';
import { BirthdaysThisWeekWidget } from '../components/widgets/BirthdaysThisWeekWidget';
import { BirthdayCalendarWidget } from '../components/widgets/BirthdayCalendarWidget';
import { CandidatesStartingWidget } from '../components/widgets/CandidatesStartingWidget';
import { InterviewsWidget } from '../components/widgets/InterviewsWidget';
import { InterviewCalendarWidget } from '../components/widgets/InterviewCalendarWidget';
import { PhoneScreenCalendarWidget } from '../components/widgets/PhoneScreenCalendarWidget';
import { EmployeesStartingCalendarWidget } from '../components/widgets/EmployeesStartingCalendarWidget';
import { CandidateModal } from '../components/CandidateModal';
import { Candidate } from '../types/hr.types';
export function HRCommandCenter() {
  const [selectedCandidate, setSelectedCandidate] = useState<Candidate | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleCandidateClick = (candidate: Candidate) => {
    setSelectedCandidate(candidate);
    setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setTimeout(() => setSelectedCandidate(null), 300);
  };
  const today = new Date();
  const formattedDate = today.toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  const userName = 'Sarah';
  return <ToastProvider data-id="element-1334">
      <div className="min-h-screen bg-gradient-to-br from-gray-50 via-orange-50/30 to-gray-50 p-6 md:p-8 font-sans text-gray-900" data-id="element-1335">
        <div className="max-w-[1600px] mx-auto space-y-6" data-id="element-1336">
          <header className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-orange-700 via-orange-600 to-orange-500 p-8 md:p-10 shadow-xl shadow-orange-600/30" data-id="element-1337">
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_rgba(255,255,255,0.15)_0%,_transparent_60%)]" data-id="element-1338"></div>
            <div className="absolute bottom-0 right-0 w-1/2 h-1/2 bg-gradient-to-tl from-white/10 to-transparent" data-id="element-1339"></div>
            <div className="relative flex items-center justify-between gap-8" data-id="element-1340">
              <div className="flex items-center gap-8" data-id="element-1341">
                <div className="flex-shrink-0" data-id="element-1342">
                  <img src="https://cdn.magicpatterns.com/uploads/nShniaYpBxVejnwixTrGRA/UML_Logo.png" alt="United Mortgage Lending" className="h-10 md:h-12 w-auto brightness-0 invert" data-id="element-1343" />
                </div>
                <div className="flex-1 min-w-0" data-id="element-1344">
                  <h1 className="text-2xl md:text-3xl font-bold text-white tracking-tight drop-shadow-sm" data-id="element-1345">
                    HR Command Center
                  </h1>
                  <p className="text-orange-100 mt-1 text-sm md:text-base" data-id="element-1346">
                    Welcome back, {userName}! Here's what's happening today.
                  </p>
                </div>
              </div>
              <div className="hidden md:block text-right" data-id="element-1347">
                <div className="text-white/90 text-sm font-medium whitespace-nowrap" data-id="element-1348">
                  {formattedDate}
                </div>
              </div>
            </div>
          </header>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1349">
            <div className="space-y-4" data-id="element-1350">
              <h2 className="text-sm font-semibold text-gray-500 uppercase tracking-wider flex items-center gap-2" data-id="element-1351">
                <div className="h-1 w-8 bg-gradient-to-r from-orange-500 to-orange-400 rounded-full" data-id="element-1352"></div>
                Today's Focus
              </h2>
              <div className="space-y-4" data-id="element-1353">
                <BirthdaysTodayWidget data-id="element-1354" />
                <CandidatesStartingWidget period="today" onCandidateClick={handleCandidateClick} data-id="element-1355" />
                <InterviewsWidget type="phone" period="today" data-id="element-1356" />
              </div>
            </div>
            <div className="space-y-4" data-id="element-1357">
              <h2 className="text-sm font-semibold text-gray-500 uppercase tracking-wider flex items-center gap-2" data-id="element-1358">
                <div className="h-1 w-8 bg-gradient-to-r from-orange-500 to-orange-400 rounded-full" data-id="element-1359"></div>
                This Week
              </h2>
              <div className="space-y-4" data-id="element-1360">
                <BirthdaysThisWeekWidget data-id="element-1361" />
                <CandidatesStartingWidget period="week" onCandidateClick={handleCandidateClick} data-id="element-1362" />
                <InterviewsWidget type="in-person" period="week" data-id="element-1363" />
              </div>
            </div>
            <div className="space-y-4" data-id="element-1364">
              <h2 className="text-sm font-semibold text-gray-500 uppercase tracking-wider flex items-center gap-2" data-id="element-1365">
                <div className="h-1 w-8 bg-gradient-to-r from-orange-500 to-orange-400 rounded-full" data-id="element-1366"></div>
                Monthly Calendars
              </h2>
              <div className="space-y-3" data-id="element-1367">
                <BirthdayCalendarWidget data-id="element-1368" />
                <PhoneScreenCalendarWidget data-id="element-1369" />
                <InterviewCalendarWidget data-id="element-1370" />
                <EmployeesStartingCalendarWidget data-id="element-1371" />
              </div>
            </div>
          </div>
        </div>
        <CandidateModal candidate={selectedCandidate} isOpen={isModalOpen} onClose={handleCloseModal} data-id="element-1372" />
      </div>
    </ToastProvider>;
}